module.exports = __webpack_public_path__ + "img/hourglass.8d88cd94.svg";